<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              查询条件
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @check="checkFun(arguments)"
        />
      </div>

      <!-- 复核 -->
      <check-dialog
        :event-type="'check'"
        :data-id="id"
        :dialog-title="dialogAddTitle"
        :dialog-visible.sync="dialogAddVisible"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 新增
import checkDialog from './checkDialog'
// 方案服务项目API
import { loadActivityWarningInfoListDataApi } from '@/api/v2/activityWarningInfoList';

export default {
  name: 'TodoCheckActivityWarningInfoList',
  components: { CustomTable2, checkDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'todo_activity_warning_info_process_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'check',
            label: '处理质量问题',
            method: 'check'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          processStatus: 1
        }
      },
      isPaging: true,
      dialogAddTitle: '',
      dialogAddVisible: false,
      id: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '省区', filterColumn: 'ts.province_names', width: 100 },
          { prop: 'cityName', label: '城市', filterColumn: 'ts.city_names', width: 100 },
          { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
          { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
          { prop: 'sellId', label: '活动编号', filterColumn: 'tawil.sell_id', width: 120 },
          { prop: 'activityName', label: '活动名称', filterColumn: 'tcs.activity_name', width: 160 },
          { prop: 'activityDate', label: '活动日期', filterColumn: 'tcs.activity_date', width: 120 },
          { prop: 'storeNames', label: '活动场所', filterColumn: 'tcs.store_names', width: 160 },
          { prop: 'userName', label: '活动人员', filterColumn: 'tu.name', width: 120 },
          { prop: 'warningTime', label: '生成时间', filterColumn: 'tawil.warning_time', width: 140 },
          { prop: 'warningInfo', label: '问题内容', filterColumn: 'tawil.warning_info', width: 180 },
          { prop: 'isAuditInfoValue', label: '是否审核生成', filterColumn: 'tawil.is_audit_info', filterValue: 'isAuditInfo', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 140 },
          { prop: 'auditResultValue', label: '审核结果', filterColumn: 'tawil.audit_result', filterValue: 'auditResult', filterArray: [{ label: '通过', value: 1 }, { label: '退回', value: 2 }], width: 120 },
          { prop: 'auditorName', label: '审核人', filterColumn: 'tawil.auditor_name', width: 120 },
          { prop: 'remark', label: '备注', filterColumn: 'tawil.remark', width: 200 },
          { prop: 'operatorName', filterColumn: 'tawil.operator_name', label: '操作人', width: 120 },
          { prop: 'operationTime', filterColumn: 'tawil.operation_time', label: '操作时间', width: 150, isBetween: true }
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.schemeNo = '';
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadActivityWarningInfoListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      let _this = this;
      _this.$emit('reloadData');
      _this.loadTableData(_this.tableList);
    },
    // 复核
    checkFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogAddTitle = '处理质量问题'
      _this.dialogAddVisible = !_this.dialogAddVisible
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
